import { ButtonGroup, FormControlSizes, HStack, ToggleButton } from '@talos/kyoko';
import { AssetLeaderboardSortPreset } from './AssetLeaderboard.types';
import { ASSET_LEADERBOARD_SORT_PRESET_LABELS } from './tokens';

const SORT_PRESET_OPTIONS: AssetLeaderboardSortPreset[] = [
  AssetLeaderboardSortPreset.Gainers,
  AssetLeaderboardSortPreset.Volume,
  AssetLeaderboardSortPreset.MarketCap,
];

interface AssetLeaderboardToolbarProps {
  /** null when the user is sorting by a column directly, so no preset button is highlighted. */
  activeSortPreset: AssetLeaderboardSortPreset | null;
  onSortPresetChange: (preset: AssetLeaderboardSortPreset) => void;
}

/** Leaderboard sort shortcuts — each jumps the grid to a fixed column + direction. */
export function AssetLeaderboardToolbar({ activeSortPreset, onSortPresetChange }: AssetLeaderboardToolbarProps) {
  return (
    <HStack w="100%" justifyContent="space-between" gap="spacing8">
      <ButtonGroup size={FormControlSizes.Small} data-testid="asset-leaderboard-sort-preset-toggle">
        {SORT_PRESET_OPTIONS.map(option => (
          <ToggleButton
            key={option}
            selected={activeSortPreset === option}
            onClick={() => onSortPresetChange(option)}
            data-testid={`asset-leaderboard-sort-preset-${option}`}
          >
            {ASSET_LEADERBOARD_SORT_PRESET_LABELS[option]}
          </ToggleButton>
        ))}
      </ButtonGroup>
    </HStack>
  );
}
